package co.maytes.standupbot.dashboard.features.standupruns.tabs

internal data class AiDegradeCta(val label: String, val href: String)

internal data class AiDegradeNotice(val reason: String, val cta: AiDegradeCta?)

internal object AiDegradeNotices {
    private const val KEY_SETTINGS_PATH = "/app/settings/integrations"
    private const val ANTHROPIC_BILLING_URL = "https://console.anthropic.com/settings/billing"

    fun forCode(code: String?): AiDegradeNotice? =
        when (code) {
            "no_key_paid" ->
                AiDegradeNotice("Paid plan needs your own Anthropic key", AiDegradeCta("Add your key", KEY_SETTINGS_PATH))
            "auth_failed" ->
                AiDegradeNotice("Your Anthropic key was rejected", AiDegradeCta("Update key", KEY_SETTINGS_PATH))
            "credit_low" ->
                AiDegradeNotice("Your Anthropic account is out of credit", AiDegradeCta("Open Anthropic", ANTHROPIC_BILLING_URL))
            "free_budget" ->
                AiDegradeNotice("This month's free AI budget is used up", AiDegradeCta("Add your key", KEY_SETTINGS_PATH))
            "cap_hit" -> AiDegradeNotice("Monthly AI cost cap reached", cta = null)
            "provider_error" -> AiDegradeNotice("Anthropic was temporarily unavailable", cta = null)
            else -> null
        }

    fun keySourceLabel(code: String?): String? =
        when (code) {
            "byok" -> "Your Anthropic key"
            "shared" -> "Shared key (free budget)"
            "none" -> "None"
            else -> null
        }
}
